import {
  RepeatedItemsListProps,
  isGroupItem
} from '@healthnz-prm/fhir-engine-renderer/types'
import { Show } from '@/components/show'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { InputFieldset } from '../inputFieldset'

export default function RepeatedItemsList({
  canAdd,
  children,
  item,
  onAdd
}: RepeatedItemsListProps) {
  if (isGroupItem(item)) {
    // force children into 1D array via flatMap
    const childrenArray = [children].flatMap(child => child)

    return (
      <div className='space-y-2'>
        {childrenArray.map((child, index) => (
          <Card key={index}>
            <CardContent>
              {child}
              <Show when={canAdd && index === childrenArray.length - 1}>
                <div className='mb-2 mt-4'>
                  <Separator />
                </div>
                <Button
                  onClick={onAdd}
                  disabled={!canAdd}
                  variant='link'
                  className='px-0'
                >
                  Add another group
                </Button>
              </Show>
            </CardContent>
          </Card>
        ))}
      </div>
    )
  }

  return (
    <InputFieldset
      disabled={item.readOnly}
      label={item.text || ''}
      required={item.required}
    >
      <div className='space-y-2'>{children}</div>
      <Show when={canAdd}>
        <Button onClick={onAdd} variant='link' className='px-0'>
          Add another value
        </Button>
      </Show>
    </InputFieldset>
  )
}
